// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__23v7m","bigColWidth":"Table_bigColWidth__3LLlX","biggerColWidth":"Table_biggerColWidth__agGPH","row":"Table_row__1u5Le","col":"Table_col__91xkC"};